import React from 'react'
import { FaGithub, FaTelegram, FaEnvelope, FaFacebook } from "react-icons/fa";
import { contactImg } from "../../assets/index";

const ContactLeft = () => {
  return (
    <div className="w-full lgl:w-[35%] h-full bg-gradient-to-r from-[#1e2024] to-[#23272b] p-4 lgl:p-8 rounded-lg shadow-shadowOne flex flex-col gap-8 justify-center">
      <img
        className="w-full h-64 object-cover rounded-lg mb-2"
        src={contactImg}
        alt="contactImg"
      />
      <div className="flex flex-col gap-4">
        <h3 className="text-3xl font-bold text-white">Brian Van Nostrand</h3>
        <p className="text-lg font-normal text-gray-400">
          E-Commerce Full Stack Developer
        </p>
        <p className="text-base text-gray-400 text-justify tracking-wide">
          I'm always open to discussing new opportunities, creative projects, or potential collaborations. Feel free to reach out if you'd like to connect!
          </p>
        <p className="text-base text-gray-400 flex items-center gap-2">
          PHONE: <span className="text-lightText">+1 (626) 596-8448</span>
        </p>
        <p className="text-base text-gray-400 flex items-center gap-2">
          EMAIL: <span className="text-lightText">Brian.Nostrand82@gmail.com</span>
        </p> 
      </div>
      <div className="flex flex-col gap-4">
        <h2 className="text-base uppercase font-titleFont mb-4">Find me in</h2>
        <div className="flex gap-4">
          <a
            href="mailto:Brian.Nostrand82@gmail.com"
            target="_blank"
            rel="noopener noreferrer"
            className="bannerIcon"
          >
            <FaEnvelope />
          </a>
          <a href="https://t.me/Bmars8218" target="_blank" rel="noopener noreferrer" className="bannerIcon">
            <FaTelegram />
          </a>
          <a href="https://www.facebook.com/bmars8218/" target="_blank" rel="noopener noreferrer" className="bannerIcon">
            <FaFacebook />
          </a>
          <a href="https://github.com/ErPing-CMS" target="_blank" rel="noopener noreferrer" className="bannerIcon">
            <FaGithub />
          </a> 
        </div>
      </div>
    </div>
  );
}

export default ContactLeft